import { ButtonHTMLAttributes, ReactNode, RefObject } from 'react';
import cx from 'classnames';
import s from './Button.module.scss';

export type ButtonVariant =
  | 'primary' // основное действие: залитая кнопка цвета палитры
  | 'secondary' // второстепенное действие: серая заливка
  | 'outline' // нейтральная обводка: «Назад», «Отмена», «Фильтр»
  | 'outline-primary' // обводка цвета палитры: «Редактировать», «Открыть»
  | 'danger' // разрушительное действие: «Удалить», «Отозвать»
  | 'danger-outline' // «Отклонить»
  | 'ghost' // без фона: иконки и действия в строках
  | 'link' // выглядит как ссылка
  | 'unstyled'; // без оформления: внешний вид целиком задаёт className

export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'onClick'> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  icon?: ReactNode;
  text?: string;
  children?: ReactNode;
  // растянуть на всю ширину контейнера
  block?: boolean;
  // атрибут type у <button>; по умолчанию не задаётся, как и раньше
  htmlType?: 'button' | 'submit' | 'reset';
  btnRef?: RefObject<HTMLButtonElement>;
  onClick?: () => void;
}

export function Button({
  variant = 'primary',
  size = 'md',
  icon,
  text,
  block,
  htmlType,
  btnRef,
  className,
  children,
  ...rest
}: ButtonProps) {
  const content = children ?? text;
  const classes =
    variant === 'unstyled'
      ? className
      : cx(
          s.button,
          s[variant],
          s[size],
          { [s.block]: block, [s.iconOnly]: icon && !content },
          className,
        );

  return (
    <button ref={btnRef} type={htmlType} className={classes} {...rest}>
      {icon && <span className={s.icon}>{icon}</span>}
      {content}
    </button>
  );
}
